import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CountSessionFragment = { __typename?: 'CountSessionDocument', id: string, productionJobId: string, productionLineId: string, targetQty: number, crewSize: number, countedQty: number, paceUnitsPerMinute: number, remainingQty: number, lastTickAt?: Types.TDateISO | null, startedAt: Types.TDateISO, startedBy: string, recipeName?: string | null, productionCategoryName?: string | null, itemName?: string | null, plantsPerPot?: number | null, jobNumber?: number | null, status: Types.CountSessionStatus, created: Types.TDateISO, updated: Types.TDateISO, pendingCorrectionId?: string | null, pendingCorrectionKind?: Types.CountCorrectionKind | null, pendingCorrectionState?: Types.CountCorrectionState | null, pendingCorrectionValue?: number | null, pendingCorrectionRequestedAt?: Types.TDateISO | null, pendingCorrectionVersion?: number | null, lastDeviceReportAt?: Types.TDateISO | null, deviceReportingStale: boolean, unitLabel: string, eachesPerUnit?: number | null, targetEaches: number, countedEaches: number, paceEachesPerMinute: number };

export type GetCountSessionsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.CountSessionDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CountSessionDocumentSortInput> | Types.CountSessionDocumentSortInput>;
}>;


export type GetCountSessionsQuery = { __typename?: 'Query', countSessions?: { __typename?: 'CountSessionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CountSessionDocument', id: string, productionJobId: string, productionLineId: string, targetQty: number, crewSize: number, countedQty: number, paceUnitsPerMinute: number, remainingQty: number, lastTickAt?: Types.TDateISO | null, startedAt: Types.TDateISO, startedBy: string, recipeName?: string | null, productionCategoryName?: string | null, itemName?: string | null, plantsPerPot?: number | null, jobNumber?: number | null, status: Types.CountSessionStatus, created: Types.TDateISO, updated: Types.TDateISO, pendingCorrectionId?: string | null, pendingCorrectionKind?: Types.CountCorrectionKind | null, pendingCorrectionState?: Types.CountCorrectionState | null, pendingCorrectionValue?: number | null, pendingCorrectionRequestedAt?: Types.TDateISO | null, pendingCorrectionVersion?: number | null, lastDeviceReportAt?: Types.TDateISO | null, deviceReportingStale: boolean, unitLabel: string, eachesPerUnit?: number | null, targetEaches: number, countedEaches: number, paceEachesPerMinute: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCountProductionLinesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionLineDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionLineDocumentSortInput> | Types.ProductionLineDocumentSortInput>;
  siteLocationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCountProductionLinesQuery = { __typename?: 'Query', countProductionLines?: { __typename?: 'CountProductionLinesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionLineDocument', id: string, tenantId: string, code: string, description: string, deviceIds: Array<string>, locationId?: string | null, activeCountSessionId?: string | null, status: Types.ProductionLineStatus, created: Types.TDateISO, updated: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCountSessionsByIdsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CountSessionDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CountSessionDocumentSortInput> | Types.CountSessionDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCountSessionsByIdsQuery = { __typename?: 'Query', countSessions?: { __typename?: 'CountSessionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CountSessionDocument', id: string, productionLineId: string, productionJobId: string, targetQty: number, countedQty: number, crewSize: number, status: Types.CountSessionStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCountSessionJobsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionJobDocumentSortInput> | Types.ProductionJobDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCountSessionJobsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', id: string, productionJobId: string, jobNumber: number, categoryName: string, genus: string, series: string, color: string, locationId?: string | null, locationName?: string | null, weekStartDate: Types.TDateISO, weekReadyDate: Types.TDateISO, quantity: number, lotStatus: Types.ProductionLotStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCountSessionJobNamesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
}>;


export type GetCountSessionJobNamesQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', id: string, productionJobId: string, jobNumber: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCountSessionJobProducedQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
}>;


export type GetCountSessionJobProducedQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', id: string, productionJobId: string, producedQuantity?: number | null, producedEaches?: number | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ProductionLineFieldsFragment = { __typename?: 'ProductionLineDocument', id: string, tenantId: string, code: string, description: string, deviceIds: Array<string>, locationId?: string | null, activeCountSessionId?: string | null, status: Types.ProductionLineStatus, created: Types.TDateISO, updated: Types.TDateISO };

export type CountSessionRowFragment = { __typename?: 'CountSessionDocument', id: string, productionLineId: string, productionJobId: string, targetQty: number, countedQty: number, crewSize: number, status: Types.CountSessionStatus };

export type CountSessionJobSummaryFragment = { __typename?: 'ProductionJobDocument', id: string, productionJobId: string, jobNumber: number, categoryName: string, genus: string, series: string, color: string, locationId?: string | null, locationName?: string | null, weekStartDate: Types.TDateISO, weekReadyDate: Types.TDateISO, quantity: number, lotStatus: Types.ProductionLotStatus };

export type ProductionLineStateFragment = { __typename?: 'ProductionLineStateData', productionLineId: string, tenantId: string, code: string, description: string, deviceIds: Array<string>, locationId?: string | null, activeCountSessionId?: string | null, status: Types.ProductionLineStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO };

export type CountSessionStartResultFragment = { __typename?: 'CountSessionStateData', countSessionId: string, productionLineId: string, productionJobId: string, crewSize: number, targetQty: number, status: Types.CountSessionStatus, countedQty: number, pendingCorrection?: { __typename?: 'PendingCountCorrection', correctionId: string, kind: Types.CountCorrectionKind, value: number, state: Types.CountCorrectionState, requestedAt: Types.TDateISO, version: number } | null };

export const CountSessionFragmentDoc = new TypedDocumentString(`
    fragment CountSession on CountSessionDocument {
  id
  productionJobId
  productionLineId
  targetQty
  crewSize
  countedQty
  paceUnitsPerMinute
  remainingQty
  lastTickAt
  startedAt
  startedBy
  recipeName
  productionCategoryName
  itemName
  plantsPerPot
  jobNumber
  status
  created
  updated
  pendingCorrectionId
  pendingCorrectionKind
  pendingCorrectionState
  pendingCorrectionValue
  pendingCorrectionRequestedAt
  pendingCorrectionVersion
  lastDeviceReportAt
  deviceReportingStale
  unitLabel
  eachesPerUnit
  targetEaches
  countedEaches
  paceEachesPerMinute
}
    `, {"fragmentName":"CountSession"});
export const ProductionLineFieldsFragmentDoc = new TypedDocumentString(`
    fragment ProductionLineFields on ProductionLineDocument {
  id
  tenantId
  code
  description
  deviceIds
  locationId
  activeCountSessionId
  status
  created
  updated
}
    `, {"fragmentName":"ProductionLineFields"});
export const CountSessionRowFragmentDoc = new TypedDocumentString(`
    fragment CountSessionRow on CountSessionDocument {
  id
  productionLineId
  productionJobId
  targetQty
  countedQty
  crewSize
  status
}
    `, {"fragmentName":"CountSessionRow"});
export const CountSessionJobSummaryFragmentDoc = new TypedDocumentString(`
    fragment CountSessionJobSummary on ProductionJobDocument {
  id
  productionJobId
  jobNumber
  categoryName
  genus
  series
  color
  locationId
  locationName
  weekStartDate
  weekReadyDate
  quantity
  lotStatus
}
    `, {"fragmentName":"CountSessionJobSummary"});
export const ProductionLineStateFragmentDoc = new TypedDocumentString(`
    fragment ProductionLineState on ProductionLineStateData {
  productionLineId
  tenantId
  code
  description
  deviceIds
  locationId
  activeCountSessionId
  status
  createdAt
  updatedAt
}
    `, {"fragmentName":"ProductionLineState"});
export const CountSessionStartResultFragmentDoc = new TypedDocumentString(`
    fragment CountSessionStartResult on CountSessionStateData {
  countSessionId
  productionLineId
  productionJobId
  crewSize
  targetQty
  status
  countedQty
  pendingCorrection {
    correctionId
    kind
    value
    state
    requestedAt
    version
  }
}
    `, {"fragmentName":"CountSessionStartResult"});
export const GetCountSessionsDocument = new TypedDocumentString(`
    query GetCountSessions($first: Int, $after: String, $where: CountSessionDocumentFilterInput, $order: [CountSessionDocumentSortInput!]) {
  countSessions(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      ...CountSession
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CountSession on CountSessionDocument {
  id
  productionJobId
  productionLineId
  targetQty
  crewSize
  countedQty
  paceUnitsPerMinute
  remainingQty
  lastTickAt
  startedAt
  startedBy
  recipeName
  productionCategoryName
  itemName
  plantsPerPot
  jobNumber
  status
  created
  updated
  pendingCorrectionId
  pendingCorrectionKind
  pendingCorrectionState
  pendingCorrectionValue
  pendingCorrectionRequestedAt
  pendingCorrectionVersion
  lastDeviceReportAt
  deviceReportingStale
  unitLabel
  eachesPerUnit
  targetEaches
  countedEaches
  paceEachesPerMinute
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCountProductionLinesDocument = new TypedDocumentString(`
    query GetCountProductionLines($where: ProductionLineDocumentFilterInput, $order: [ProductionLineDocumentSortInput!], $siteLocationId: String, $first: Int, $after: String, $last: Int, $before: String) {
  countProductionLines(
    where: $where
    order: $order
    siteLocationId: $siteLocationId
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...ProductionLineFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionLineFields on ProductionLineDocument {
  id
  tenantId
  code
  description
  deviceIds
  locationId
  activeCountSessionId
  status
  created
  updated
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCountSessionsByIdsDocument = new TypedDocumentString(`
    query GetCountSessionsByIds($where: CountSessionDocumentFilterInput, $order: [CountSessionDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  countSessions(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...CountSessionRow
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CountSessionRow on CountSessionDocument {
  id
  productionLineId
  productionJobId
  targetQty
  countedQty
  crewSize
  status
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCountSessionJobsDocument = new TypedDocumentString(`
    query GetCountSessionJobs($where: ProductionJobDocumentFilterInput, $order: [ProductionJobDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionJobs(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...CountSessionJobSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CountSessionJobSummary on ProductionJobDocument {
  id
  productionJobId
  jobNumber
  categoryName
  genus
  series
  color
  locationId
  locationName
  weekStartDate
  weekReadyDate
  quantity
  lotStatus
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCountSessionJobNamesDocument = new TypedDocumentString(`
    query GetCountSessionJobNames($first: Int, $where: ProductionJobDocumentFilterInput) {
  productionJobs(first: $first, where: $where) {
    nodes {
      id
      productionJobId
      jobNumber
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCountSessionJobProducedDocument = new TypedDocumentString(`
    query GetCountSessionJobProduced($first: Int, $where: ProductionJobDocumentFilterInput) {
  productionJobs(first: $first, where: $where) {
    nodes {
      id
      productionJobId
      producedQuantity
      producedEaches
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCountSessions: build.query<GetCountSessionsQuery, GetCountSessionsQueryVariables | void>({
      query: (variables) => ({ document: GetCountSessionsDocument, variables })
    }),
    GetCountProductionLines: build.query<GetCountProductionLinesQuery, GetCountProductionLinesQueryVariables | void>({
      query: (variables) => ({ document: GetCountProductionLinesDocument, variables })
    }),
    GetCountSessionsByIds: build.query<GetCountSessionsByIdsQuery, GetCountSessionsByIdsQueryVariables | void>({
      query: (variables) => ({ document: GetCountSessionsByIdsDocument, variables })
    }),
    GetCountSessionJobs: build.query<GetCountSessionJobsQuery, GetCountSessionJobsQueryVariables | void>({
      query: (variables) => ({ document: GetCountSessionJobsDocument, variables })
    }),
    GetCountSessionJobNames: build.query<GetCountSessionJobNamesQuery, GetCountSessionJobNamesQueryVariables | void>({
      query: (variables) => ({ document: GetCountSessionJobNamesDocument, variables })
    }),
    GetCountSessionJobProduced: build.query<GetCountSessionJobProducedQuery, GetCountSessionJobProducedQueryVariables | void>({
      query: (variables) => ({ document: GetCountSessionJobProducedDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCountSessionsQuery, useLazyGetCountSessionsQuery, useGetCountProductionLinesQuery, useLazyGetCountProductionLinesQuery, useGetCountSessionsByIdsQuery, useLazyGetCountSessionsByIdsQuery, useGetCountSessionJobsQuery, useLazyGetCountSessionJobsQuery, useGetCountSessionJobNamesQuery, useLazyGetCountSessionJobNamesQuery, useGetCountSessionJobProducedQuery, useLazyGetCountSessionJobProducedQuery } = injectedRtkApi;
